<ul class="password-strength-checklist" aria-live="polite">
  <li [class.is-valid]="flags.minLength">
    <span aria-hidden="true">{{ flags.minLength ? '✔' : '✘' }}</span>
    <span>{{ flags.minLength ? 'Atendido' : 'Pendente' }}: mínimo de 8 caracteres</span>
  </li>
  <li [class.is-valid]="flags.uppercase">
    <span aria-hidden="true">{{ flags.uppercase ? '✔' : '✘' }}</span>
    <span>{{ flags.uppercase ? 'Atendido' : 'Pendente' }}: uma letra maiúscula</span>
  </li>
  <li [class.is-valid]="flags.lowercase">
    <span aria-hidden="true">{{ flags.lowercase ? '✔' : '✘' }}</span>
    <span>{{ flags.lowercase ? 'Atendido' : 'Pendente' }}: uma letra minúscula</span>
  </li>
  <li [class.is-valid]="flags.number">
    <span aria-hidden="true">{{ flags.number ? '✔' : '✘' }}</span>
    <span>{{ flags.number ? 'Atendido' : 'Pendente' }}: um número</span>
  </li>
  <li [class.is-valid]="flags.specialChar">
    <span aria-hidden="true">{{ flags.specialChar ? '✔' : '✘' }}</span>
    <span>{{ flags.specialChar ? 'Atendido' : 'Pendente' }}: um caractere especial</span>
  </li>
</ul>
